export default __webpack_public_path__ + "static/media/GCC_Playbook2@2x.28897847.jpg";